export default __webpack_public_path__ + "static/media/taxonomy.181454ef.png";